export default "/assets/images/chart-06.svg?2618d77346bdc223cc72b8e7f636fc6e";